import dayjs from 'dayjs';
import 'highlight.js/styles/base16/unikitty-light.css';
import Image from 'next/image';
import Link from 'next/link';
import { useProcessor } from '../useProcessor';
import { PostData } from '../utils';
import { BlogTableOfContents } from './TableOfContents';

interface Props {
  postData: PostData;
}

export const BlogPostContent = ({ postData }: Props) => {
  const { content, tableOfContents } = useProcessor(postData.htmlContent);

  return (
    <section className="w-full px-4 py-10 md:py-20 box-border bg-lupine-50">
      <div className="max-w-5xl mx-auto ">
        <div className="md:max-w-[83.3%]">
          <h1
            className="font-sans text-2xl md:text-5xl font-medium leading-tight text-plum-950 mb-8 -tracking-[0.03em]">
            {postData.title}
          </h1>
          <p className="font-sans text-lg md:text-2xl text-fog-900 mb-6 -tracking-[0.02em]">
            {postData.description}
          </p>

          <div className="font-sans text-base text-fog-950 mb-6">
            {dayjs(postData.date).format('MMMM D, YYYY')} &middot;{' '}
            {postData.readingTime} minute read
          </div>

          <div className="flex items-center gap-2 mb-12">
            <Image
              src={postData.author.profilePictureUrl}
              width={60}
              height={60}
              alt={postData.author.name}
              priority
              className="rounded-full"
            />
            <div className="flex flex-col gap-1 font-sans text-base text-fog-900">
              <div className="font-sans text-base text-fog-900 font-medium mb-3">
                {postData.author.name}
              </div>
              <div className="font-sans text-base text-fog-900">
                {postData.author.role}
              </div>
            </div>
          </div>
        </div>

        <Image
          src={postData.featuredImage}
          width={960}
          height={600}
          alt=""
          priority
          className="w-full h-auto rounded-xl"
        />

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
          <div className="md:col-span-2">{content}</div>
          {/* 132px represents nav (84px) plus content margin (48px) */}
          <div
            className="hidden md:flex flex-col gap-12 sticky top-[132px] max-h-[calc(100vh-132px)] pb-4 overflow-y-scroll">
            <BlogTableOfContents tableOfContents={tableOfContents} />
            <div className="p-8 rounded-2xl border border-plum-100">
              <h2 className="font-sans text-lg text-plum-950 bold mb-4">
                Automate RFP, RFI, and Security Questionnaires with Wolfia today!
              </h2>
              <hr className="border-b border-plum-100 my-4" />
              <Link
                href="https://calendly.com/naren-mano/wolfia-demo"
                target="_blank"
                className="bg-plum-600 border border-plum-800 p-4 block text-center rounded-xl hover:bg-plum-800 transition-colors shadow-md mb-4"
              >
              <span className="block font-sans font-semibold text-sm text-fog-50">
                Schedule demo
              </span>
              </Link>
              {/*<Link*/}
              {/*  href="https://calendly.com/naren-mano/wolfia-demo"*/}
              {/*  target="_blank"*/}
              {/*  className="bg-fog-50 border border-fog-200 p-4 block text-center rounded-xl hover:bg-fog-100 transition-colors shadow-md"*/}
              {/*>*/}
              {/*  <span className="block font-sans font-semibold text-sm text-plum-950">*/}
              {/*    Request demo {`->`}*/}
              {/*  </span>*/}
              {/*</Link>*/}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
